import React from "react"
import PropTypes from "prop-types"

const LanguageToggle = ({ languageLink, languageUrl }) => {
  return (
    <div className="language-toggle">
      <div className="toggle-container">
        <a href={languageUrl}>{languageLink}</a>
      </div>
      <div className="globe"></div>
    </div>
  )
}

LanguageToggle.propTypes = {
  languageLink: PropTypes.string.isRequired,
  languageUrl: PropTypes.string.isRequired,
}

export default LanguageToggle
